import React from 'react';
import { Select } from 'components/Form';
import { useTranslation } from 'react-i18next';

const WinningPointsSelect = ({ options }) => {
  const { t } = useTranslation();

  return (
    <Select
      name="gameSettings.winningPoints"
      options={options}
      label={t('Points to play')}
      placeholder={t('Select points...')}
    />
  );
};

export default WinningPointsSelect;
